import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import EventsPage from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import Records from "@/pages/Records";
import Partners from "@/pages/Partners";
import About from "@/pages/About";
import Register from "@/pages/Register";
import Login from "@/pages/Login";
import AthleteDetail from "@/pages/AthleteDetail";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import Admin from "@/pages/Admin";
import { Privacy, Terms, NotFound } from "@/pages/Legal";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-right" toastOptions={{
            style: { background: "#0d0d0d", border: "1px solid #2a2a2a", color: "#fff", borderRadius: 0 }
          }} />
          <Routes>
            <Route path="/admin/login" element={<Layout><Login /></Layout>} />
            <Route path="/admin/forgot-password" element={<Layout><ForgotPassword /></Layout>} />
            <Route path="/admin/reset-password" element={<Layout><ResetPassword /></Layout>} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/events" element={<Layout><EventsPage /></Layout>} />
            <Route path="/events/:slug" element={<Layout><EventDetail /></Layout>} />
            <Route path="/records" element={<Layout><Records /></Layout>} />
            <Route path="/athletes/:slug" element={<Layout><AthleteDetail /></Layout>} />
            <Route path="/partners" element={<Layout><Partners /></Layout>} />
            <Route path="/about" element={<Layout><About /></Layout>} />
            <Route path="/register" element={<Layout><Register /></Layout>} />
            <Route path="/privacy" element={<Layout><Privacy /></Layout>} />
            <Route path="/terms" element={<Layout><Terms /></Layout>} />
            <Route path="*" element={<Layout><NotFound /></Layout>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
